import { Typography, styled } from '@mui/material';
import { colors } from 'theme/colors';

export const StyledTitle = styled(Typography)(() => ({
  textTransform: 'uppercase',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '24px',
  letterSpacing: '2%',
  color: colors.primary500,
}));
